export default __webpack_public_path__ + "static/media/google-forms-setup.0b9f38f2.gif";